import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LayerProvider } from "@astryxdesign/core/Layer";
import { AuthProvider } from "./features/auth/AuthProvider";

// Base styles must load before any component renders, or Astryx components
// render unstyled — this ordering is Astryx's own setup contract, not a
// preference.
import "@astryxdesign/core/reset.css";
import "@astryxdesign/core/astryx.css";
import "./theme/madhani.css";

import App from "./App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Camera list/status data is cheap to refetch and changes on its own
      // (stream state, viewer counts), so staleness is not worth tracking —
      // components that need freshness poll or subscribe explicitly instead.
      staleTime: 5_000,
      retry: 1,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LayerProvider toast={{ position: "bottomEnd" }}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </LayerProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>,
);
